import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { map, Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';


@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileBudgetApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_budgets';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  create(data:object){
    return this.restCreate<any>(data);
  }

  delete(id:string){
    return this.restDelete(id);
  }

  // Dedicated sub-resource: just this team's budgets (org-wide pot excluded).
  listByTeam(teamId:string): Observable<HydraCollection<any>> {
    return this.http.get<HydraCollection<any>>(`${this.apiUrl}/organisation_profile_teams/${teamId}/budgets`).pipe(
      map(response => new HydraCollection<any>(response))
    );
  }

  // This team's spend / remaining / overspend position.
  teamSummary(teamId:string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/organisation_profile_teams/${teamId}/budget_summary`);
  }
}
